// extracted by mini-css-extract-plugin
export default {"wrapper":"VariationsColumnsWrapper_wrapper__WQAiw","scrollContainer":"VariationsColumnsWrapper_scrollContainer__eUvhv"};